<div class="sidebar-root">
  @if(showSidenavDockToggle && !sidenavCollapsedState) {
  <button
    type="button"
    mat-icon-button
    class="sidebar-sidenav-dock-toggle"
    [attr.aria-expanded]="true"
    (click)="toggleCollapsed.emit()">
    <i-tabler name="layout-sidebar-left-collapse" class="sidebar-sidenav-dock-toggle__icon d-flex"></i-tabler>
  </button>
  }

  <div class="sidebar-header d-flex align-items-center">
    <div class="branding"><app-branding layout="sidebar"></app-branding></div>

    <div class="sidebar-header__actions">
      @if(showSidebarCollapseDropdowns) {
      <button
        type="button"
        mat-icon-button
        class="sidebar-header-action-btn sidebar-collapse-dropdowns-btn"
        [attr.aria-label]="'side_menu.collapse_all_dropdowns' | translate"
        [matTooltip]="'side_menu.collapse_all_dropdowns' | translate"
        (click)="collapseAllDropdowns()">
        <mat-icon>unfold_less</mat-icon>
      </button>
      }

      @if(showToggle) {
      <a
        href="javascript:void(0)"
        (click)="toggleMobileNav.emit()"
        class="d-flex justify-content-center ng-star-inserted icon-40 align-items-center"
      >
        <i-tabler name="x" class="icon-20 d-flex"></i-tabler>
      </a>
      }
    </div>
  </div>
</div>
